<template>
  <div>
<!--    <breadcrumb :routerList="[{to:'/establish/customerLvyueQudaoTable',title:'返利管理'},{title:'客户履约报表渠道'}]"/>-->
    <Breadtabsheader/>
    <div class="h-content w-content">
      <!--查询表单-->
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="客户编码" prop="agentCode">
                <el-input v-model="q.agentCode" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="客户名称" prop="agentName">
                <el-input v-model="q.agentName" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="渠道" prop="channelCode">
                <brselect category="fl_sales_region_qudao" :v="q.channelCode" v-model="q.channelCode" :multiple="true"
                          :clearable="true"/>
              </el-form-item>
              <el-form-item label="链群" prop="rebateChainGroup">
                <brselect category="rebate_chain_group" :v="q.rebateChainGroup" v-model="q.rebateChainGroup" :multiple="true"
                          :clearable="true"/>
              </el-form-item>
            </div>
            <el-collapse-transition>
              <div v-show="isScreen">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="年份" prop="year">
                    <el-select filterable v-model="q.year" clearable placeholder="请选择">
                      <el-option value="2023">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="区域" prop="area">
                    <brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :multiple="true"
                              :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="状态" prop="channel">
                    <brselect category="fl_lvyue_quit_status" :v="q.isUse" v-model="q.isUse"
                              :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="领域" prop="field">
                    <brselect category="fl_field" :v="q.field" v-model="q.field"
                              :clearable="true"/>
                  </el-form-item>
                </div>
              </div>
            </el-collapse-transition>
            <div class="l-screenBox">
              <div class="l-screen" @click="collapseChange">
                <img :src="isScreen?closeScreen:drawScreen" alt="">
                <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
              </div>
              <div class="l-retrieval">
                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                <el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置</el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>


      <!--展示表格-->
      <div class="h-table h-mrt30">
        <el-table :model="q"
                  ref="q"
                  :data="tableData"
                  stripe
                  style="width: 100%"
                  :border="true"
                  :summary-method="getSummaries"
                  show-summary
                  max-height="530"
        >
          <el-table-column
              prop="area"
              :show-overflow-tooltip="true"
              label="区域"
              width="80"
              fixed
          >
          </el-table-column>
          <el-table-column
              prop="agentCode"
              :show-overflow-tooltip="true"
              label="客户编码"
              width="110"
              fixed
          >
          </el-table-column>
          <el-table-column
              prop="agentName"
              :show-overflow-tooltip="true"
              label="客户名称"
              min-width="180"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.agentName }}
              </div>
            </template>
          </el-table-column><el-table-column
                prop="field"
                :show-overflow-tooltip="true"
                label="领域"
                width="80"
                fixed
        >
          <template slot-scope="scope">
            <div style="text-align: left;">
              {{scope.row.field|dictname('fl_field')}}
            </div>
          </template>
        </el-table-column>
          <el-table-column
              prop="channelCode"
              :show-overflow-tooltip="true"
              label="渠道"
              width="120"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.channelCode|dictname('fl_sales_region_qudao')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="rebateChainGroup"
              :show-overflow-tooltip="true"
              label="链群"
              width="100"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;" v-if="scope.row.rebateChainGroup == 'ND5' && scope.row.rebateSeries != ''">
                {{ scope.row.rebateChainGroup|dictname('rebate_chain_group')}}-{{ scope.row.rebateSeries}}
              </div>
              <div style="text-align: left;" v-if="scope.row.rebateChainGroup != 'ND5' || scope.row.rebateSeries == null || scope.row.rebateSeries == ''">
                {{ scope.row.rebateChainGroup|dictname('rebate_chain_group')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="1月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi1"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.tongqi1).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="janM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.janM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="jan"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.jan).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="janL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">
                  {{ (Number(scope.row.janL).toFixed(2)) + '%' }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="2月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi2"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.tongqi2).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="febM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.febM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="feb"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.feb).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="febL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ (Number(scope.row.febL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="3月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi3"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.tongqi3).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="marM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.marM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="mar"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.mar).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="marL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ (Number(scope.row.marL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="一季度" :show-overflow-tooltip="true">
            <el-table-column
                    prop="firstQuarterT"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ Number(scope.row.firstQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="firstQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ Number(scope.row.firstQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="firstQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ Number(scope.row.firstQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="firstQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ (Number(scope.row.firstQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="4月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi4"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.tongqi4).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="aprM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.aprM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="apr"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.apr).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="aprL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ (Number(scope.row.aprL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="5月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi5"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.tongqi5).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="mayM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.mayM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="may"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.may).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="mayL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ (Number(scope.row.mayL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="6月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi6"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.tongqi6).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="junM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.junM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="jun"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.jun).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="junL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ (Number(scope.row.junL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="二季度" :show-overflow-tooltip="true">
            <el-table-column
                    prop="secondQuarterT"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ Number(scope.row.secondQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="secondQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ Number(scope.row.secondQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="secondQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ Number(scope.row.secondQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="secondQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ (Number(scope.row.secondQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="7月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi7"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.tongqi7).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="julM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.julM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="jul"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.jul).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="julL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ (Number(scope.row.julL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="8月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi8"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.tongqi8).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="augM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.augM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="aug"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.aug).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="augL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ (Number(scope.row.augL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="9月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi9"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.tongqi9).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sepM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.sepM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sep"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.sep).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sepL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ (Number(scope.row.sepL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="三季度" :show-overflow-tooltip="true">
            <el-table-column
                    prop="thirdQuarterT"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ Number(scope.row.thirdQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="thirdQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ Number(scope.row.thirdQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="thirdQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ Number(scope.row.thirdQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="thirdQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ (Number(scope.row.thirdQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="10月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi10"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.tongqi10).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="octM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.octM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="oct"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.oct).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="octL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ (Number(scope.row.octL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="11月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi11"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.tongqi11).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="novM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.novM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="nov"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.nov).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="novL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ (Number(scope.row.novL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="12月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi12"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.tongqi12).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="deceM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.deceM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="dece"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.dece).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="deceL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ (Number(scope.row.deceL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="四季度" :show-overflow-tooltip="true">
            <el-table-column
                    prop="fourthQuarterT"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ Number(scope.row.fourthQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="fourthQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ Number(scope.row.fourthQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="fourthQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ Number(scope.row.fourthQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="fourthQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 1 && scope.row.rebateChainGroup == 'ND5'">/</div>
                <div style="text-align: right;" v-if="scope.row.type == 4 || scope.row.rebateChainGroup != 'ND5'">{{ (Number(scope.row.fourthQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="全年合计" :show-overflow-tooltip="true">
            <el-table-column
                    prop="yearT"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.yearT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="yearM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.yearM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="yearS"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ Number(scope.row.yearS).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="yearL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;" v-if="scope.row.type == 4">/</div>
                <div style="text-align: right;" v-if="scope.row.type != 4">{{ (Number(scope.row.yearL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
              prop="isUse"
              :show-overflow-tooltip="true"
              label="状态"
              width="80"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.isUse | dictname('fl_lvyue_quit_status')}}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel" v-auth="'khlybbXs_daochu'">批量导出
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from '../../../api/SystemService'
import updownfile from '../../../utils/updownfile'

export default {
  components: {},
  data() {
    return {
      // 展开折叠筛选
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      q: {
        agentName: '',
        agentCode: '',
        channel: null,
        rebateChainGroup: null,
        year: 2023,
        type: '',
        areaCode: null,
        isUse:'',
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      //table列表
      tableData: [],
      countlist:'',
    }
  },
  created() {
    this.q = {
      agentName: '',
      agentCode: '',
      channel: null,
      rebateChainGroup: null,
      year: 2023,
      type: '',
      isUse:'',
      areaCode: null,
      pageSize: 10,
      pageNo: 1,
      total: 0
    };
    this.handleFilter();
  },
  methods: {
    // 展开折叠
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    //检索
    handleFilter() {
      this.query();
      this.queryTotal();
    },
    //重置
    reset() {
      this.q = {
        agentName: '',
        agentCode: '',
        channel: null,
        rebateChainGroup: null,
        year: 2023,
        type: '',
        areaCode: null,

        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      this.handleFilter();
    },
    //查询table
    query() {
      ss.fanli.getLyQudaoPage(this.q).then(rd => {
        this.q.total = rd.total;
        this.tableData = rd.records;
      });
    },
    queryTotal() {
      ss.fanli.getLyQudaoTotal(this.q).then(rd=>{
        this.countlist = rd;
      });

    },
    //批量导出
    exportExcel() {
      updownfile.down("/api/swyl/v1/fl/flQudaoSalesVolume/downloadExcelQudao", this.q, "post");
    },
    getSummaries(param){
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        console.log(column,index)
        if (index === 0) {
          sums[index] = '总计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[6] = Number(this.countlist.tongqi1).toFixed(2);
          sums[7] = Number(this.countlist.janM).toFixed(2);
          sums[8] = Number(this.countlist.jan).toFixed(2);
          sums[9] = this.countlist.janM?Number(this.countlist.jan*100/this.countlist.janM).toFixed(2)+'%':'0.00%';
          sums[10] = Number(this.countlist.tongqi2).toFixed(2);
          sums[11] = Number(this.countlist.febM).toFixed(2);
          sums[12] = Number(this.countlist.feb).toFixed(2);
          sums[13] = this.countlist.febM?Number(this.countlist.feb*100/this.countlist.febM).toFixed(2) + '%':'0.00%';
          sums[14] = Number(this.countlist.tongqi3).toFixed(2);
          sums[15] = Number(this.countlist.marM).toFixed(2);
          sums[16] = Number(this.countlist.mar).toFixed(2);
          sums[17] = this.countlist.marM?Number(this.countlist.mar*100/this.countlist.marM).toFixed(2) + '%':'0.00%';
          sums[18] = Number(this.countlist.firstQuarterT).toFixed(2);
          sums[19] = Number(this.countlist.firstQuarterM).toFixed(2);
          sums[20] = Number(this.countlist.firstQuarter).toFixed(2);
          sums[21] = this.countlist.firstQuarterM?Number(this.countlist.firstQuarter*100/this.countlist.firstQuarterM).toFixed(2) + '%':'0.00%';
          sums[22] = Number(this.countlist.tongqi4).toFixed(2);
          sums[23] = Number(this.countlist.aprM).toFixed(2);
          sums[24] = Number(this.countlist.apr).toFixed(2);
          sums[25] = this.countlist.aprM?Number(this.countlist.apr*100/this.countlist.aprM).toFixed(2) + '%':'0.00%';
          sums[26] = Number(this.countlist.tongqi5).toFixed(2);
          sums[27] = Number(this.countlist.mayM).toFixed(2);
          sums[28] = Number(this.countlist.may).toFixed(2);
          sums[29] = this.countlist.mayM?Number(this.countlist.may*100/this.countlist.mayM).toFixed(2) + '%':'0.00%';
          sums[30] = Number(this.countlist.tongqi6).toFixed(2);
          sums[31] = Number(this.countlist.junM).toFixed(2);
          sums[32] = Number(this.countlist.jun).toFixed(2);
          sums[33] = this.countlist.junM?Number(this.countlist.jun*100/this.countlist.junM).toFixed(2) + '%':'0.00%';
          sums[34] = Number(this.countlist.secondQuarterT).toFixed(2);
          sums[35] = Number(this.countlist.secondQuarterM).toFixed(2);
          sums[36] = Number(this.countlist.secondQuarter).toFixed(2);
          sums[37] = this.countlist.secondQuarterM?Number(this.countlist.secondQuarter*100/this.countlist.secondQuarterM).toFixed(2) + '%':'0.00%';
          sums[38] = Number(this.countlist.tongqi7).toFixed(2);
          sums[39] = Number(this.countlist.julM).toFixed(2);
          sums[40] = Number(this.countlist.jul).toFixed(2);
          sums[41] = this.countlist.julM?Number(this.countlist.jul*100/this.countlist.julM).toFixed(2) + '%':'0.00%';
          sums[42] = Number(this.countlist.tongqi8).toFixed(2);
          sums[43] = Number(this.countlist.augM).toFixed(2);
          sums[44] = Number(this.countlist.aug).toFixed(2);
          sums[45] = this.countlist.augM?Number(this.countlist.aug*100/this.countlist.augM).toFixed(2) + '%':'0.00%';
          sums[46] = Number(this.countlist.tongqi9).toFixed(2);
          sums[47] = Number(this.countlist.sepM).toFixed(2);
          sums[48] = Number(this.countlist.sep).toFixed(2);
          sums[49] = this.countlist.sepM?Number(this.countlist.sep*100/this.countlist.sepM).toFixed(2) + '%':'0.00%';
          sums[50] = Number(this.countlist.thirdQuarterT).toFixed(2);
          sums[51] = Number(this.countlist.thirdQuarterM).toFixed(2);
          sums[52] = Number(this.countlist.thirdQuarter).toFixed(2);
          sums[53] = this.countlist.thirdQuarterM?Number(this.countlist.thirdQuarter*100/this.countlist.thirdQuarterM).toFixed(2) + '%':'0.00%';
          sums[54] = Number(this.countlist.tongqi10).toFixed(2);
          sums[55] = Number(this.countlist.octM).toFixed(2);
          sums[56] = Number(this.countlist.oct).toFixed(2);
          sums[57] = this.countlist.octM?Number(this.countlist.oct*100/this.countlist.octM).toFixed(2) + '%':'0.00%';
          sums[58] = Number(this.countlist.tongqi11).toFixed(2);
          sums[59] = Number(this.countlist.novM).toFixed(2);
          sums[60] = Number(this.countlist.nov).toFixed(2);
          sums[61] = this.countlist.novM?Number(this.countlist.nov*100/this.countlist.novM).toFixed(2) + '%':'0.00%';
          sums[62] = Number(this.countlist.tongqi12).toFixed(2);
          sums[63] = Number(this.countlist.deceM).toFixed(2);
          sums[64] = Number(this.countlist.dece).toFixed(2);
          sums[65] = this.countlist.deceM?Number(this.countlist.dece*100/this.countlist.deceM).toFixed(2) + '%':'0.00%';
          sums[66] = Number(this.countlist.fourthQuarterT).toFixed(2);
          sums[67] = Number(this.countlist.fourthQuarterM).toFixed(2);
          sums[68] = Number(this.countlist.fourthQuarter).toFixed(2);
          sums[69] = this.countlist.fourthQuarterM?Number(this.countlist.fourthQuarter*100/this.countlist.fourthQuarterM).toFixed(2) + '%':'0.00%';
          sums[70] = Number(this.countlist.yearT).toFixed(2);
          sums[71] = Number(this.countlist.yearM).toFixed(2);
          sums[72] = Number(this.countlist.yearS).toFixed(2);
          sums[73] = this.countlist.yearM?Number(this.countlist.yearS*100/this.countlist.yearM).toFixed(2) + '%':'0.00%';
        } else {
          sums[1] = '';
          sums[2] = '';
          sums[3] = '';
          sums[4] = '';
          sums[5] = '';
          sums[74] = '';
        }
      });

      return sums;
    },
  }
}
</script>
<style lang="scss">
.el-table thead.is-group th {
  background-color: #57aefe;
}

.w-content .el-table__footer-wrapper .cell {
  text-align: right;
}

.w-content .el-table__fixed-footer-wrapper tbody td {
  background: #cce7ff;
}

.w-content .el-table__footer-wrapper tbody td {
  background: #cce7ff;
}

.el-table--scrollable-x .el-table__body-wrapper {
  z-index: 1;
}

.el-table__fixed, .el-table__fixed-right {
  box-shadow: none;
}

.el-table__fixed, .el-table__fixed-right {
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    content: '';
    z-index: 100;
    box-shadow: 0 0 10px rgba(0, 0, 0, .12);
  }
}

.el-table__fixed-footer-wrapper tbody td {
  border-top: 0;
}
</style>
